import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft, ChevronDown } from "lucide-react";

const QA = [
  ["Is MakeYourBrand.IN really fully automated?", "Yes — onboard once, connect your channels, and AI handles content, replies, SEO, websites, campaigns and analytics. You set the approval rules; AI respects them."],
  ["Do you replace a human marketing agency?", "For 80% of small-to-mid businesses, yes. For brands with regulatory exposure (finance, healthcare, legal) you'll still want a human reviewer — our approval workflow makes that easy."],
  ["Which platforms do you support?", "Instagram, Facebook, LinkedIn, X (Twitter), YouTube, Google Business Profile, Pinterest and Threads. WhatsApp & Email campaigns also supported."],
  ["How long does setup take?", "5 minutes. Multi-step onboarding wizard, then the AI generates your brand identity, website and first month of content automatically."],
  ["What AI models do you use?", "Latest large language models (Gemini 3, Claude 4) for text, and Nano Banana for images. We continuously evaluate and upgrade — you always get the best available."],
  ["Is my data safe?", "Yes. Encrypted in transit (TLS 1.3) and at rest. Connection tokens encrypted with AES-256. GDPR & DPDP compliant. Cancel and export anytime."],
  ["Can the AI mess up?", "Sensitive content (legal threats, refund disputes, abuse) is auto-escalated to humans. Everything else can be set to require approval before publish. You're always in control."],
  ["Do you offer white-label for agencies?", "Yes — Agency plan ($299) includes white-label client portal, custom branding, team seats and API access."],
  ["What if I cancel?", "Cancel anytime. Access continues until the billing period ends. You can export your data including logos, content and brand assets."],
  ["How do I pay?", "Manual payment for MVP — once you choose a plan, our team activates it within hours. Stripe & PayPal coming soon."],
];

export default function FAQ() {
  return (
    <div className="min-h-screen bg-[#05050A] text-white grid-bg p-6 lg:p-12" data-testid="faq-root">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white mb-10">
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>
        <div className="flex items-center gap-2 mb-8">
          <div className="h-9 w-9 rounded-lg brand-gradient grid place-items-center">
            <Sparkles className="h-5 w-5" />
          </div>
          <span className="font-heading font-black text-lg tracking-tight">
            MakeYour<span className="brand-gradient-text">Brand.IN</span>
          </span>
        </div>

        <div className="text-xs uppercase tracking-[0.25em] text-orange-400/80 mb-3">Frequently asked</div>
        <h1 className="font-heading text-4xl lg:text-5xl font-black tracking-tight mb-10">Answers, fast.</h1>

        <div className="space-y-3">
          {QA.map(([q, a], i) => (
            <details key={i} className="glass rounded-2xl p-5 group" data-testid={`faq-${i}`}>
              <summary className="cursor-pointer list-none flex items-center justify-between">
                <span className="font-semibold">{q}</span>
                <ChevronDown className="h-4 w-4 text-white/40 group-open:rotate-180 transition" />
              </summary>
              <p className="text-white/70 mt-4 leading-relaxed">{a}</p>
            </details>
          ))}
        </div>
      </div>
    </div>
  );
}
